var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('core-page',{attrs:{"title":"Connect!"}},[_c('core-connect-button')],1)}
var staticRenderFns = []

export { render, staticRenderFns }